module.exports = __webpack_public_path__ + "static/media/iconProfessor.ba08575b.svg";